/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quote': {
    width: 23,
    height: 20,
    viewBox: '0 0 23 20',
    data: '<path pid="0" d="M5.32 19.08c2.7 0 4.8-1.98 4.8-4.92 0-2.22-1.08-3.78-2.82-4.5L9.7.48H4.9L1.72 9C.64 11.76.4 12.78.4 14.16c0 2.88 2.04 4.92 4.92 4.92zm12.72 0c2.7 0 4.8-1.98 4.8-4.92 0-2.22-1.08-3.78-2.82-4.5l2.4-9.18h-4.8L14.44 9c-1.08 2.76-1.32 3.78-1.32 5.16 0 2.88 2.04 4.92 4.92 4.92z" _fill="#FFF" fill-rule="nonzero"/>'
  }
})
